import { render, staticRenderFns } from "./AstaTavolo.vue?vue&type=template&id=3c6c3718&scoped=true&"
import script from "./AstaTavolo.vue?vue&type=script&lang=js&"
export * from "./AstaTavolo.vue?vue&type=script&lang=js&"
import style0 from "./AstaTavolo.vue?vue&type=style&index=0&id=3c6c3718&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c6c3718",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/diego/Desktop/code/asta-live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c6c3718')) {
      api.createRecord('3c6c3718', component.options)
    } else {
      api.reload('3c6c3718', component.options)
    }
    module.hot.accept("./AstaTavolo.vue?vue&type=template&id=3c6c3718&scoped=true&", function () {
      api.rerender('3c6c3718', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AstaTavolo.vue"
export default component.exports